import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { API_URL } from "../../utils/constant";
import { useFetchData } from "../../hooks/useFetchData";
import React, { useEffect, useState } from "react";
import axios from "axios";

const headers = [
  {
    key: "adjustment_date",
    name: "Adj Date",
  },
  {
    key: "product_name",
    parent: "product",
    name: "Product Name",
  },
  {
    key: "quantity",
    name: "Quantity",
  },
  {
    key: "warehouse_name",
    parent: "warehouse",
    name: "Warehouse",
  },
  {
    key: "adjustment_method",
    name: "Method",
  },
  {
    key: "status",
    name: "Status",
  },
];

const AdjustmentList = () => {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const [units, setUnits] = useState([]);
  useEffect(() => {
    axios
      .get(API_URL + "/unit", { withCredentials: true })
      .then((res) => setUnits(res.data.data || []))
      .catch((err) => console.error("Failed to load units", err));
  }, []);
  const detailPopupHeaders = [
    {
      key: "adjustment_number",
      name: "Adjustment ID",
    },
    {
      key: "warehouse_name",
      parent: "warehouse",
      name: "Warehouse Name",
    },
    {
      key: "product_name",
      parent: "product",
      name: "Product Name",
    },
    {
      key: "barcode",
      name: "Barcode",
    },
    {
      key: "quantity",
      name: "Quantity",
    },
    {
      key: "sku_unit_id",
      parent: "productPrice",
      name: "SKU",
      render: (value) => {
        const found = units.find((u) => u.unit_id === value);
        return found ? found.unit_name : value;
      },
    },
    {
      key: "adjustment_method",
      name: "Method",
    },
    {
      key: "adjustment_date",
      name: "Adjustment Date",
    },
    {
      key: "remark",
      name: "Remark",
    },
  ];

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/adjustment",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      setSearchValue(trimmed); // Store search term
      setQuery({
        search: value.trim(),
      });
    } else {
      setSearchValue(""); // Clear search term
      setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Adjustment List"
      data={data}
      headers={headers}
      detailPopupTitle="Adjustment Information"
      detailPopupHeaders={detailPopupHeaders}
      idKey="adjustment_id"
      endPoint="/adjustment"
      setCurrentPage={setCurrentPage}
      removeEdit={true}
      hasSearch
      hasCreate
      hasActions
      module="Warehouse"
      subModule="Adjustment"
      createPath={`/warehouse/adjustment/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default AdjustmentList;
